import i18n from "../i18n"; // Adjust the path based on your project structure

const getPostTime = (createdAt) => {
  const timeDiff = Date.now() - Date.parse(createdAt);
  const timeDiffInMinutes = timeDiff / 1000 / 60;
  const timeDiffInHours = timeDiffInMinutes / 60;
  const timeDiffInDays = timeDiffInHours / 24;
  const timeDiffInWeeks = timeDiffInDays / 7;
  const timeDiffInMonths = timeDiffInDays / 30;
  const timeDiffInYears = timeDiffInDays / 365;

  if (timeDiffInMinutes < 1) return i18n.t("time.now");
  if (timeDiffInMinutes < 60)
    return `${Math.round(timeDiffInMinutes)}${i18n.t("time.minute")}`;
  if (timeDiffInHours < 24)
    return `${Math.round(timeDiffInHours)}${i18n.t("time.hour")}`;
  if (timeDiffInDays < 7)
    return `${Math.round(timeDiffInDays)}${i18n.t("time.day")}`;
  if (timeDiffInWeeks < 5)
    return `${Math.round(timeDiffInWeeks)}${i18n.t("time.week")}`;
  if (timeDiffInMonths < 12)
    return `${Math.round(timeDiffInMonths)}${i18n.t("time.month")}`;
  return `${Math.round(timeDiffInYears)}${i18n.t("time.year")}`;
};

export default getPostTime;
